import { Outlet, useLocation } from 'react-router';

import AppLayout from '@/shared/layout/AppLayout';
import Header from '@/shared/layout/Header';
import { buildSiteComplianceSettingsPath } from '../siteComplianceRouting';

const alwaysTrue = () => true;

const openSiteComplianceMobileFilters = () => {
  window.dispatchEvent(new CustomEvent('site-compliance:open-mobile-filters'));
};

const SiteComplianceLayout = () => {
  const location = useLocation();

  return (
    <AppLayout
      header={
        <Header
          showMobileMenuButton={location.pathname === '/'}
          onMobileMenuClick={openSiteComplianceMobileFilters}
          settingsPath={buildSiteComplianceSettingsPath}
        />
      }
      shouldUseMobileDocumentFlow={alwaysTrue}
      shouldAwaitRouteLoadingSignal={alwaysTrue}
    >
      <Outlet />
    </AppLayout>
  );
};

export default SiteComplianceLayout;
